import { Button } from "@/components/ui/button";
import FileDownloadIcon from "@/icons/FileDownload";
import { cn } from "@/lib/utils";
import Link from "next/link";

export default function SpecsWithoutTopSix({
  productSpecifications = [],
  specificationPdfUrl,
  isAccessory = false,
}) {
  const RenderDownloadBtn = (className = "") =>
    specificationPdfUrl &&
    specificationPdfUrl !== undefined && (
      <div
        className={cn(
          "flex items-center justify-center lg:justify-center pr-[12rem] lg:pr-0",
          className
        )}
      >
        <Link
          href={specificationPdfUrl}
          target="_blank"
          className="flex justify-center items-end "
        >
          <Button className=" hover:bg-inherit inline-flex gap-2 border border-blue1 text-blue3 text-[14px] h-10 rounded-[8px] bg-transparent lg:h-[42px]">
            <FileDownloadIcon /> Download Specification Sheet
          </Button>
        </Link>
      </div>
    );

  return (
    <>
      <div className="py-5 px-9 lg:p-5 ">
        {isAccessory && RenderDownloadBtn("pr-0")}
        <div className="mt-[30px] lg:mt-[18px]">
          <div className="mt-[10px]">
            {productSpecifications.length > 0 &&
              productSpecifications?.map(({ category, details }, index) => {
                return (
                  <div key={index} className="mb-[10px] lg:mb-1">
                    <h3 className="pl-4 text-blue3 font-bold text-[17px] leading-[25px] mb-2">
                      {category}
                    </h3>
                    <div className="grid grid-cols-2 gap-x-10 lg:gap-x-5 900:grid-cols-1">
                      {details.length > 0 &&
                        details.map((detail, i) => (
                          <div
                            key={i}
                            className="grid grid-cols-2 text-blue3 text-[17px] leading-[22px] border border-gray16 border-b-0"
                          >
                            <p className=" bg-gray17 py-[9px] font-medium pl-4 border-b border-gray16 lg:text-[14px]">
                              {detail.key} {detail.unit}
                            </p>
                            <p className=" pl-[34px] py-[9px] border-b border-gray16 lg:text-[14px]">
                              {detail.value}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <span>{RenderDownloadBtn()}</span>
    </>
  );
}
